<template>
  <div>
    <div style="margin-bottom:10px;">
      <el-button type="primary" @click="exportData()">导出最近1000条交易记录</el-button>
    </div>
    <xtable :config="config" :data="data" @clickRowBtn="" @clickMultiBtn="" ref="mytable"></xtable>
  </div>
</template>
<script>
import ajax from 'xelement/ajax'
import Xtable from 'xelement/table'
import { api } from 'src/config'

export default {
  data() {
    return {
      data: api.dealLog.seller,
      config: {
        base: {
          showIndex: false
        },
        selection: false,
        expand: false,
        query: false,
        rowBtns: false,
        page: true,
        field: [
          {
            id: 'time',
            text: '时间',
            width: '240'
          },
          {
            id: 'money',
            text: '金额',
            width: '180'
          },
          {
            id: 'balance',
            text: '当时余额',
            width: '180'
          },
          {
            id: 'type',
            text: '交易类型',
            formatter: 'balanceType',
            width: '180'
          },
          {
            id: '_order.name',
            text: '客户姓名',
            width: '120'
          },
          {
            id: '_order.tel',
            text: '客户电话',
            width: '160'
          },
          {
            id: '_order.address',
            text: '客户地址',
            width: '240',
            tooltip: true
          },
          {
            id: '_order.content',
            text: '订单详情',
            width: '240',
            tooltip: true
          },
          {
            id: 'remark',
            text: '备注'
          }
        ]
      }
    }
  },
  methods: {
    exportData(){
      let query = {
        page: 1,
        pageSize: 1000,
        sortField: '',
        sortOrder: '',
        mode: 'export'
      };
      let queryStr = '?';
      for(let i in query){
        queryStr += '';
        queryStr += i + '=' + query[i] + '&';
      }
      queryStr = queryStr.substring(0, queryStr.length - 1);
      window.open(api.dealLog.seller + queryStr);
    }
  },
  components: {
    Xtable
  }
}
</script>


// WEBPACK FOOTER //
// log_money.vue?4416ae21